import { StateDropDown } from '@apply/components/';
import { useBorrowerEntityStateIncorporated } from '../../../../../../../queries/BorrowerFields/EntityFields';
import { ApplicationQuestionReviewItem } from '../../../../../../components/ApplicationQuestionReviewItem';
import UsaStates, { IStateResult } from 'usa-states';

interface StateIncorporatedProps {
    readOnly?: boolean;
    isReview?: boolean;
}

export const StateIncorporated: React.FC<StateIncorporatedProps> = ({ readOnly = false, isReview = false }) => {
    const label = 'State Incorporated';
    const [state, set_state] = useBorrowerEntityStateIncorporated();
    const usaStates: IStateResult[] = new UsaStates.UsaStates().states;
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={usaStates.find((s) => s.abbreviation == state)?.name}
                />
            ) : (
                <div style={{ marginTop: 16 }}>
                    <StateDropDown
                        id={'stateDropDown'}
                        value={state}
                        onChange={(value) => set_state(value)}
                        label={label}
                        required={true}
                        readOnly={readOnly}
                    />
                </div>
            )}
        </>
    );
};
